import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '~/common/components/PageTitle';
import { useAxeAccountAnalytics } from '~/common/contexts/analytics';
import globalStyles from '../app.css';
import ApiKeyManagement from '../containers/ApiKeyManagement';

const Settings: React.FC = () => {
  const { t } = useTranslation();
  const analytics = useAxeAccountAnalytics();

  useEffect(() => {
    analytics.viewApiKeysPage();
  }, []);

  return (
    <div className={globalStyles.wrap}>
      <PageTitle title={t('Settings - Manage API Key')} />
      <ApiKeyManagement />
    </div>
  );
};

export default Settings;
